import React, {Component} from 'react';

class BsyWebhookEventMenu extends Component {
    state = {
        eventType: 1,
    }

    switchEventMenu = (e) =>{
        return ()=>{
            this.setState({
                eventType:e
            })
        }
    }

    render() {
        const {eventType} = this.state
        return (
            <div className="BsyWebhookEventMenu">
                <div className="event-menu">
                    <div className={"title " + (eventType === 1 ? "select" : "")} onClick={this.switchEventMenu(1)}>1. {React.language('member.change')}</div>
                    <div className={"title " + (eventType === 2 ? "select" : "")} onClick={this.switchEventMenu(2)}>2. {React.language('dept.change')}</div>
                    <div className={"title " + (eventType === 3 ? "select" : "")} onClick={this.switchEventMenu(3)}>3. {React.language('role.change')}</div>
                    <div className={"title " + (eventType === 4 ? "select" : "")} onClick={this.switchEventMenu(4)}>4. {React.language('external.contact.change')}</div>
                </div>
                {eventType === 1 && <div className="list">
                    <div className="item">{React.language('member.contact.add')}</div>
                    <div className="item">{React.language('member.contact.edit')}</div>
                    <div className="item">{React.language('member.contact.del')}</div>
                    <div className="item">{React.language('member.contact.recover')}</div>
                    <div className="item">{React.language('member.to.external')}</div>
                    <div className="item">{React.language('member.to.dept')}</div>
                </div>}
                {eventType === 2 && <div className="list">
                    <div className="item">{React.language('dept.create')}</div>
                    <div className="item">{React.language('dept.edit')}</div>
                    <div className="item">{React.language('dept.del')}</div>
                </div>}
                {eventType === 3 && <div className="list">
                    <div className="item">{React.language('add.role')}</div>
                    <div className="item">{React.language('edit.role')}</div>
                    <div className="item">{React.language('edit.add.user')}</div>
                    <div className="item">{React.language('edit.del')}</div>
                    <div className="item">{React.language('edit.del.user')}</div>
                </div>}
                {eventType === 4 && <div className="list">
                    <div className="item">{React.language('external.add.group')}</div>
                    <div className="item">{React.language('external.edit.group')}</div>
                    <div className="item">{React.language('external.del.group')}</div>
                    <div className="item">{React.language('external.add')}</div>
                    <div className="item">{React.language('external.del')}</div>
                    <div className="item">{React.language('external.edit')}</div>
                    <div className="item">{React.language('external.to.dept')}</div>
                </div>}
            </div>
        );
    }
}

export default BsyWebhookEventMenu;